export const Permissions = {
  ResumePage: "resumePage",
  ResumesPage: "resumesPage",
  ChangeReview: "changeLogPage",
  AdvancedSearch: "advancedSearchPage",
  MetricsPage: "metricsPage",
  TransferDataPage: "transferDataPage",
  ScheduledForAIPage: "scheduledForAIScoringPage",
  ResumeTrackerPage: "resumeTrackerPage",
  ResumeExclusionPage: "resumeExclusionPage",
  RegionalLeadersPage: "regionalLeadersPage",
  ReconcileDataPage: "reconcileDataPage",
  PermissionManagementPage: "permissionManagementPage",
  ManagersPage: "managersPage",
  LogsPage: "logsPage",
  EmployeeUploadPage: "employeeUploadPage",
  EmployeesPage: "employeesPage",
  DataRequestsPage: "dataRequestsPage",
  ConfigurationPage: "configurationPage",
  ImportsPage: "importsPage",
  NotificationsPage: "notificationsPage",
  ResumeFlagAdministration: "resumeFlagAdministrationPage",
  SkillAdministrationPage: "skillAdministrationPage",
  FlagJobsPage: "flagJobsPage",
  BugReportPage: "bugReportPage",
  ResumeFlagExceptionPage: "resumeFlagExceptionPage",
  JobLogPage: "jobLogPage",
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];
